<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios Gerais</app-titulo>
      <div class="header-buttons" *ngIf="selectedReport">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"
          [disabled]="isTerminalList && !terminalSelecionado"></app-botao>
        <app-botao *ngIf="isPdfReport" type="primario" class="button" text="Gerar PDF" icon="assets/download.svg"
          (click)="gerarPDF()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">{{ reportTitle }}</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input type="select" label="Relatório" placeholder="Selecione" name="REPORT_TYPE"
              formControlName="REPORT_TYPE" [selectData]="reportOptions" [preserveOrder]="true"
              (ngModelChange)="onChangeReportType($event)" width="100%"></app-input>

            <app-input *ngIf="isTerminalList" type="select" label="Terminal" placeholder="Selecione" name="PK_DTNR"
              formControlName="PK_DTNR" [selectData]="terminalOptions" [coerceValue]="'number'"
              width="100%"></app-input>

            <app-input type="datetime-local" label="Data Início" placeholder="Digite aqui" name="DT_INIC"
              formControlName="DT_INIC" width="100%"></app-input>
            <app-input type="datetime-local" label="Data Fim" placeholder="Digite aqui" name="DT_FIM"
              formControlName="DT_FIM" width="100%"></app-input>
          </form>
        </div>
      </div>

      <div class="carretas-patio-wrapper" *ngIf="isTerminalList && terminalSelecionado">
        <div class="carretas-patio-badge">
          <svg class="carretas-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 55" fill="currentColor">
            <rect x="2" y="5" width="62" height="34" rx="2" />
            <path d="M64,5 L64,39 L88,39 L88,22 Q88,18 85,15 L76,5 Z" />
            <rect x="72" y="9" width="13" height="14" rx="1" fill="white" />
            <rect x="2" y="39" width="86" height="4" />
            <circle cx="18" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
            <circle cx="34" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
            <circle cx="78" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
          </svg>
          <span>{{ quantidadeCaminhoes }} caminhões no período</span>
        </div>
      </div>

      <div class="table-scroll" *ngIf="isTerminalList && !isLoading">
        <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
      </div>
    </div>
  </div>

  <app-subtitulo *ngIf="isTerminalList && terminalSelecionado && !isLoading && !tableData.length">
    Nenhum registro encontrado.
  </app-subtitulo>

  <div class="paginacao" *ngIf="isTerminalList">
    <app-paginacao *ngIf="tableData.length" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
